import { inject, Injectable } from '@angular/core';
import { CanActivateFn } from '@angular/router';

import { NavigationService } from '../../navigation/service/navigation.service';
import { AppointmentCreationService } from '../service/appointment-creation.service';

@Injectable()
export class IdentificationStepGuard {
  constructor(
    private readonly appointmentCreationService: AppointmentCreationService,
    private readonly navigationService: NavigationService,
  ) {}

  canActivate(): boolean {
    const appointmentInformation =
      this.appointmentCreationService.selectedAppointmentInformation$.value;
    if (appointmentInformation !== null) {
      return true;
    }

    this.navigationService.navigateToHomePageWithoutMedicalCenter();

    return false;
  }
}

export const canActivate: CanActivateFn = () =>
  inject(IdentificationStepGuard).canActivate();
